import { render, staticRenderFns } from "./BindBrandsView.vue?vue&type=template&id=7bf2abc4"
import script from "./BindBrandsView.vue?vue&type=script&lang=js"
export * from "./BindBrandsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports